import { Space, Spin } from 'antd'
import { Main } from 'components/ActionStyles/ActionStyles'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import FileReader from 'components/Uploader/FileReader'
import FileUploader from 'components/Uploader/Uploader.js'

import Download from 'components/icons/Download'
import {
  BoldText,
  InfoSection,
  LightText,
  SampleDocContainer,
} from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { SmallButtons } from '../../../components/Uploader/Styles'
import BellIcon from '../../../components/icons/BellIcon'

import { env } from 'utils/const'
import { FolderSpinner } from '../../Placement/style'
import { HeaderBold,SubHeader } from '../StyleComponents/style'

const AlertFlex = styled(Flex)`
  background: ${COLORS.BLUR_T_90};
  border: 1px solid ${COLORS.BLUR_T_95};
  border-radius: 10px;
  padding: 10px;
  margin: 15px 0;
  gap: 12px;
`

const TextWrapper = styled(Flex)`
  padding-left: 12px;
  margin-bottom: 5px;
`
const SubTextWrapper = styled(Flex)`
  padding-left: 20px;
  line-height: initial;
  align-items: baseline;
`
const ResultWrapper = styled(Flex)`
  line-height: initial;
  align-items: center;
  gap: 3px;
`
const StyledH2 = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  padding-top: 10px;
  margin-left: 9px;
`
const Cirlcle = styled.div`
  padding: 4px;
  background: #4d566e;
  border-radius: 50% !important;
  margin-right: 9px;
`

const StyledP = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
  padding-top: 5px;
  line-height: initial;
  width: 100%;
`
const ResultUploader = ({
  roleId,
  bulkUpload,
  progress,
  setFailed,
  failed,
  bulkUploadResult,
  finalUpload,
  setFinalUpload,
  stage,
  openDrawer,
  isLoading = false,
  setIsLoading,
  handleResolveConflict,
  handleUploadClick,
  conflictStatus,
  candidates,
  file,
  setFile,
  bulkUploadError,
  setShowErrorTable
}) => {
  const [isUploaded, setIsUploaded] = useState(false)
  const [isLoading1, setIsLoading1] = useState(false)
  const [fileURL, setFileURL] = useState('')
  const onFileUploaded = fileData => {
    setFile(fileData)
    setShowErrorTable(false)
  }

  useEffect(() => {
    if (openDrawer) {
      setFile({})
    }
  }, [openDrawer])


  let currentTime = new Date().getTime()
  const downloadURI = () => {
    let uri =
    env.CORPORATE_BULK_TEMPLATE ||
      'https://d18zc7o1u7b8o7.cloudfront.net/students/bulkupload/Corporate_Template_Bulkupload.xlsx'
    let name = 'SampleDoc'
    let link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  return (
   
    
        <>
          <InfoSection>
            <Space>
              <SmallButtons
                height={'30px'}
                width="30px"
                border={true}
                icon={<Download />}
              />
              <SampleDocContainer>
                <BoldText>Download Template</BoldText>
                <LightText>To Upload bulk upload data, use template</LightText>
              </SampleDocContainer>
            </Space>
            <Main>
              <Button.Secondary
                onClick={downloadURI}
                trigger={['click']}
                text="Download"
              ></Button.Secondary>
            </Main>
          </InfoSection>
          <br></br>
          <HeaderBold>
          Upload new corporates
          </HeaderBold>
          <SubHeader>
          Upload result in Excel sheet
          </SubHeader>
          {!file?.url  && (
           
            <FileUploader
                  isDefault={true}
                  file={file}
                  setFile={onFileUploaded}
                  setFileURL={setFileURL}
                  fileURL={fileURL}
                  setIsLoading={setIsLoading1}
                  bgcolor={'#F9FAFE'}
                  borderColor={'#D6DBF7'}
                  fileName={`Corporate File`}
                  format="(.xlsx, .csv)"
                  accept=".xlsx, .csv"
                  message={'Invalid file uploaded'}
                  // height={'165px'}
                />
          )}
         

          {isLoading ? (
            <FolderSpinner style={{ marginTop: '3rem' }}>
              <Spin small tip="Loading" size="large" />
            </FolderSpinner>
          ) : (
            <>
              {file?.url && (
                <FileReader
                file={file}
                setFile={setFile}
             
                progress="100"
                // setErrorMessage={setErrorMessage}
                handleRemoveClick={() => 
                  {
                    setFile({});
                    setFileURL('')
                  }
                  }
              />
              )}
              {!file?.url && (
                <AlertFlex>
                  <Control column top="2px" bottom="2px">
                    <TextWrapper alignCenter>
                      <>
                        {' '}
                        <BellIcon />{' '}
                        <StyledH2 alignCenter> Please note!</StyledH2>
                      </>
                    </TextWrapper>
                  
                    <SubTextWrapper>
                      <Cirlcle />
                      <StyledP>
                        Enter the details only to the allotted fields
                      </StyledP>
                    </SubTextWrapper>
                  </Control>
                </AlertFlex>
              )}
            
            
            </>
          )}
        </>
 
   
  )
}

export default ResultUploader
